import { render, staticRenderFns } from "./PaymentModal.vue?vue&type=template&id=652ebd23&"
import script from "./PaymentModal.vue?vue&type=script&lang=ts&"
export * from "./PaymentModal.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentModal.vue?vue&type=style&index=0&id=652ebd23&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports